import { $, $$, getNextSibling } from '../../../shared/js/utils/dom';
import { Shower } from '../../../shared/js/modules/shower';
import Bus from '../../../shared/js/modules/event-bus';
import { generateRandomString } from '../../../shared/js/utils/unique-string';
import { isMobile } from '../../../shared/js/globals/breakpoints';
import { initRedirects } from '../../_accessibility/focus-redirect';
// import { Shower } from '@3pc/shower';

const navMain = $('.nav-main');
let navMainIsOpen = false;
const toggles = navMain ? $$('.nav-main__expand-toggle', navMain) : [];
const showerInstancesPerNavLevel = {};
const navMainShowerInstances = [];

class NavMainShower {
  constructor(params) {
    this.toggle = params.toggle;
    this.content = getNextSibling(this.toggle, '.nav-main__expand-content');
    this.close = $('.nav-main__expand-close', this.content);
    this.navLevel = parseInt(this.toggle.closest('[data-level]').dataset.level);
    this.showerInstance = undefined;
  }

  init = () => {
    this.setupShower();
    Bus.subscribe(
      'navmain_close-below-level',
      'NavMainCloseBelowLevel',
      this.closeBelowNavLevel
    );
    Bus.subscribe('resize', 'NavMainResize', this.onResize);
    this.toggle.addEventListener('keydown', this.onKeydown);
    this.content.addEventListener('keydown', this.onKeydown);
  };

  setupShower = () => {
    if (this.content) {
      this.setupAriaAttributes(this.toggle, this.content);
      this.showerInstance = new Shower({
        target: this.content,
        handler: this.toggle,
        duration: 300,
        initOpened: false,
        openClassName: 'is-open',
        toggleStart: (_, state) => {
          // IF 1st navLevel emit event 'navmain_open'
          if (state === 'show' && this.navLevel === 1 && !isMobile)
            navMainIsOpen = true;
          if (state !== 'show' && this.navLevel === 1 && !isMobile)
            navMainIsOpen = false;

          if (navMainIsOpen) {
            navMain.classList.add('nav-main--is-open');
            Bus.broadcast('navmain_open', null);
          }
        },
        toggleEnd: (_, state) => {
          // IF 1st navLevel emit event 'navmain_close'
          if (state !== 'show' && this.navLevel === 1 && !isMobile) {
            if (!navMainIsOpen) {
              navMain.classList.remove('nav-main--is-open');
              Bus.broadcast('navmain_close', null);
            }
          }
          // Close below navLevel on close of above level
          if (state !== 'show')
            Bus.broadcast('navmain_close-below-level', {
              belowLevel: this.navLevel + 1,
            });
        },
      });

      this.showerInstance.init();

      // Store Shower according to its nav level
      showerInstancesPerNavLevel[`nav-level-${this.navLevel}`] =
        showerInstancesPerNavLevel[`nav-level-${this.navLevel}`] || [];
      showerInstancesPerNavLevel[`nav-level-${this.navLevel}`].push(
        this.showerInstance
      );
    }
  };

  closeBelowNavLevel = e => {
    const closeLevel = e.belowLevel;
    const levelInstances =
      showerInstancesPerNavLevel[`nav-level-${closeLevel}`];
    if (levelInstances)
      levelInstances.forEach(instance => {
        if (instance.show) instance.close();
      });
  };

  closeClick = () => {
    this.showerInstance.close();
    this.toggle.focus();
  };

  emitNavMainStateEvent = () => {
    if (this.showerInstance.show) {
      Bus.broadcast('navmain_open', null);
      return;
    }
    Bus.broadcast('navmain_close', null);
  };

  // First nav level

  setupFirstNavLevelShower = () => {
    this.showerInstance.closeInstances = [];

    if (this.navLevel !== 1) return;

    // Unbind previous eventListener
    if (this.close) this.close.removeEventListener('click', this.closeClick);

    this.showerInstance.el.removeEventListener(
      'focusout',
      this.closeFirstNavLevelShowerOnFocusout
    );
    this.showerInstance.handler.removeEventListener(
      'focusout',
      this.closeFirstNavLevelShowerOnFocusout
    );

    // IF desktop
    if (!isMobile) {
      // Bind close button
      if (this.close) this.close.addEventListener('click', this.closeClick);
      // Only allow one first level nav shower to be open at a time,
      this.showerInstance.closeInstances = showerInstancesPerNavLevel[
        'nav-level-1'
      ].filter(shower => shower !== this.showerInstance);

      // Close first level nav shower if focus leaves.
      this.showerInstance.el.addEventListener(
        'focusout',
        this.closeFirstNavLevelShowerOnFocusout
      );
      this.showerInstance.handler.addEventListener(
        'focusout',
        this.closeFirstNavLevelShowerOnFocusout
      );
    }
  };

  closeFirstNavLevelShowerOnFocusout = e => {
    if (
      this.showerInstance.show &&
      !this.showerInstance.el.contains(e.relatedTarget) &&
      !e.relatedTarget !== this.showerInstance.handler
    )
      this.showerInstance.close();
  };

  // Aria-attributes

  setupAriaAttributes = (toggle, content) => {
    const uniqueId = `nav-main-content-${generateRandomString(
      toggle.offsetTop
    )}`;
    toggle.setAttribute('aria-controls', uniqueId);
    content.setAttribute('id', uniqueId);
  };

  // Event handler

  onAllShowerReady = () => {
    this.setupFirstNavLevelShower();
  };

  onResize = () => {
    this.setupFirstNavLevelShower();
  };

  onKeydown = e => {
    if (e.key === 'Escape') this.closeClick();
  };
}

// General Shower setup
toggles.forEach(toggle => {
  const navItemShower = new NavMainShower({
    toggle,
  });
  navItemShower.init();
  navMainShowerInstances.push(navItemShower);
});

// Things to be done when all Shower are initialized.
navMainShowerInstances.forEach(instance => {
  instance.onAllShowerReady();
});

// Focus Handling

const navMainFocusHandler = () => {
  const ulFirstLevel = $('.nav-main[data-level="1"]');
  const ulFirstLevelConfig =
    "{ 'smartphone': { 'next': { 'onFocusout': true, 'selector': '.header__accessibility .nav-meta__link' } }, 'desktop': {} }";
  const firstLinkFirstLevel = $('[data-level="1"] > .nav-main__link');
  const firstLinkFirstLevelConfig =
    "{ 'smartphone': { 'previous': { 'selector': '.header__nav-main-burger' } }, 'desktop': {} }";
  const closeButtons = $$('.nav-main__expand-close');
  const closeButtonsConfig =
    "{ 'desktop': {'next': {'selectClosestElement': true, 'selector': '.nav-main__item .nav-main__expand-toggle'} } }";

  ulFirstLevel?.setAttribute('data-focus-redirect', ulFirstLevelConfig);
  firstLinkFirstLevel?.setAttribute(
    'data-focus-redirect',
    firstLinkFirstLevelConfig
  );
  closeButtons?.map(closeButton =>
    closeButton.setAttribute('data-focus-redirect', closeButtonsConfig)
  );

  initRedirects([ulFirstLevel, firstLinkFirstLevel, ...closeButtons]);
};

navMainFocusHandler();
